import { App } from '@omni/kit/services/Types';
import { DOMAIN_LIBRARY } from '../Constants';
import { Domain } from '../types';
import { IFavoriteApp } from '@omni/kit/contexts/FavoriteAppsContext';
import { SelectOption } from '@omni/kit/components/KitSelect';
import i18n from '@omni/kit/localization';
import memberAppLabelContextKey from '@omni/kit/utilities/memberAppLabelContextKey';

export interface SearchableState {
  searchable: boolean;
}

export type AppFilterOption = SelectOption & SearchableState;

export const initAppFilterOptions = (
  activeApp: App | undefined,
  rootApp: App | undefined,
  favoriteApps: IFavoriteApp[]
): AppFilterOption[] => {
  let options: AppFilterOption[] = [];

  // 1. active app
  if (Boolean(activeApp?.id)) {
    options = [
      ...options,
      {
        label: activeApp?.title ?? '',
        value: activeApp?.id ?? '',
        searchable:
          (activeApp?._embedded?.['app-features'] ?? []).filter(
            (item) => item.name === 'search:media' && item.enabled
          ).length > 0,
      },
    ];
  }

  const favoriteAppOptions: AppFilterOption[] = favoriteApps
    .map((item) => {
      const option: AppFilterOption = {
        label: item.title ?? '',
        value: item.appkey,
        searchable: Boolean(item.is_media_search_enabled),
      };

      return option;
    })
    .filter((item) => {
      // excluding active app to avoid redundant option
      return item.value !== activeApp?.id;
    });

  if (favoriteAppOptions.length > 0) {
    // 2. 'All favorited churches|campuses|sites'
    options = [
      ...options,
      {
        label: i18n.t('search:filterOptionAllFavorited', {
          context: memberAppLabelContextKey(rootApp),
        }),
        value: favoriteApps.map((item) => item.appkey).join(','),
        searchable:
          favoriteAppOptions.filter((item) => item.searchable).length > 0,
      },
    ];

    // 3+. List of all favorites
    options = [...options, ...favoriteAppOptions];
  }

  return options;
};

export const isAppFilterValueSearchable = (
  appFilterValue: string,
  appFilterOptions: AppFilterOption[],
  domain: Domain
): boolean => {
  if (domain === DOMAIN_LIBRARY) {
    return (
      appFilterOptions.filter(
        (item) => item.value === appFilterValue && item.searchable
      ).length > 0
    );
  }

  return true;
};
